import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M.552 2.278c0-.155.077-.368.357-.63s.722-.527 1.319-.762C3.418.416 5.105.112 7 .112s3.582.304 4.772.774c.597.235 1.038.5 1.32.762.28.262.356.475.356.63s-.077.368-.357.63c-.28.261-.722.526-1.319.762-1.19.47-2.877.774-4.772.774S3.418 4.14 2.228 3.67c-.597-.236-1.038-.5-1.32-.763-.28-.261-.356-.474-.356-.63m12.96 1.89a6.3 6.3 0 0 1-1.281.665c-1.37.54-3.22.86-5.231.86-2.012 0-3.861-.32-5.231-.86a6.3 6.3 0 0 1-1.281-.666v3.178c.056.085.135.178.246.279.29.263.745.53 1.36.766 1.224.471 2.959.776 4.906.776s3.682-.305 4.907-.776c.614-.237 1.069-.503 1.359-.766q.163-.151.246-.28zM.488 11.208V8.993c.341.213.732.4 1.156.564 1.402.539 3.295.859 5.356.859s3.954-.32 5.356-.86a7 7 0 0 0 1.156-.563v2.216C13.512 12.749 10.597 14 7 14S.488 12.75.488 11.209",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const programmingComputerDatabase = { render };
export {
  programmingComputerDatabase as default,
  render
};
//# sourceMappingURL=programming-computer-database.svg.js.map
